// extracted by mini-css-extract-plugin
module.exports = {"errorMainWindow":"style_errorMainWindow__1OYxy","msg":"style_msg__avJvK"};